import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider
} from '@mui/material';
import styled from 'styled-components';

const Section = styled(Box)`
  padding: 4rem 0;
`;

const ContentPaper = styled(Paper)`
  padding: 2rem;
  margin-top: 2rem;
`;

const Terms: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Section>
        <Typography variant="h3" align="center" gutterBottom>
          Terms of Service
        </Typography>
        <Typography variant="subtitle1" align="center" color="textSecondary" gutterBottom>
          Last Updated: March 2024
        </Typography>

        <ContentPaper elevation={1}>
          <Typography variant="body1" paragraph>
            Welcome to XCH.live. By accessing or using our service, you agree to be bound by these Terms of Service.
            Please read these terms carefully before using our platform.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            1. Service Description
          </Typography>
          <Typography variant="body1" paragraph>
            XCH.live provides a blockchain monitoring service for Chia cryptocurrency wallets. Our service allows users
            to monitor their cold storage wallets without requiring access to private keys. We do not provide custody
            services, trading facilities, or direct access to blockchain transactions.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            2. User Responsibilities
          </Typography>
          <List>
            <ListItem>
              <ListItemText
                primary="Account Security"
                secondary="You are responsible for maintaining the security of your account credentials and any wallet information you provide."
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="Accurate Information"
                secondary="You must provide accurate and up-to-date information when using our service."
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="Legal Compliance"
                secondary="You agree to use our service in compliance with all applicable laws and regulations."
              />
            </ListItem>
          </List>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            3. Service Limitations
          </Typography>
          <Typography variant="body1" paragraph>
            Our service is provided "as is" and "as available." While we strive for 100% uptime and accuracy,
            we cannot guarantee uninterrupted access to our services or the accuracy of blockchain data.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            4. Privacy and Data
          </Typography>
          <Typography variant="body1" paragraph>
            We collect and process data in accordance with our Privacy Policy. By using our service,
            you consent to such processing and you warrant that all data provided by you is accurate.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            5. Fees and Payment
          </Typography>
          <Typography variant="body1" paragraph>
            Fees for our services are clearly displayed before purchase. We accept payment in both
            cryptocurrency and traditional payment methods. All fees are non-refundable unless
            otherwise required by law.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            6. Termination
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right to terminate or suspend access to our service immediately, without prior
            notice or liability, for any reason whatsoever, including without limitation if you breach
            these Terms of Service.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            7. Limitation of Liability
          </Typography>
          <Typography variant="body1" paragraph>
            In no event shall XCH.live, nor its directors, employees, partners, agents, suppliers, or
            affiliates, be liable for any indirect, incidental, special, consequential or punitive
            damages, including without limitation, loss of profits, data, use, goodwill, or other
            intangible losses.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            8. Changes to Terms
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right to modify or replace these Terms at any time. If a revision is material,
            we will provide at least 30 days' notice prior to any new terms taking effect.
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography variant="body2" color="textSecondary" align="center">
            By using XCH.live, you acknowledge that you have read and understood these Terms of Service
            and agree to be bound by them.
          </Typography>
        </ContentPaper>
      </Section>
    </Container>
  );
};

export default Terms; 